
import React, { Component } from "react";
import { connect } from "react-redux";
import { assessmentActions } from "../../../../_actions";
import StudentHeader from "../Component/StudentHeader";
import NewSchoolModal from "../Component/NewSchoolModal";
import SchoolEditModal from "../Component/SchoolEditModal";
import DeleteSchoolModal from "../Component/DeleteSchoolModal";
import SendCampaign from "./SendCampaign";

import { IoIosArrowForward, IoIosSearch } from "react-icons/io";
import { LiaFileExcel } from "react-icons/lia";
import { IoArrowBack } from "react-icons/io5";

import { MdOutlineEdit } from "react-icons/md";
import { MdOutlineMail } from 'react-icons/md';
import { MdOutlineAnalytics } from "react-icons/md";
import { RiDeleteBinLine } from "react-icons/ri";
import { saveAs } from 'file-saver';
import * as XLSX from 'xlsx';
import moment from 'moment';

// import Select from 'react-select';
// import { PiDotsThreeOutlineFill } from "react-icons/pi";

class CampaignList extends Component {
  constructor(props) {
    super(props);
    this.handleDownloadExcel = this.handleDownloadExcel.bind(this);
    this.state = {
      showSchoolModal: false,
      updateSchoolModal: false,
      deleteSchoolModal: false,
      formSchoolData: {
        "name": "",
        "email": "",
        "mobile": ""
      },
      updateFormSchoolData: {
        "id": "",
        "name": "",
        "email": "",
        "mobile": ""
      },
      openCampaignModel: "",
      size: 10,
      campsize: 10,
      crrSchoolId: this.props.match.params.id,
      campaignFormData: {
        title: "",
        subject: "",
        emailName: "",
        message: "",
        teamname: "",
        list: []
      }
    };
  }

  componentDidMount() {
    let paginationData = {
      "keyWord": "",
      "pageNo": 1,
      "size": this.state.campsize,
      "schoolId": this.state.crrSchoolId
    }
    this.props.dispatch(assessmentActions.getCoachCampaignList(paginationData));
    window.scrollTo(0, 0);
  }

  handleNewSchoolModal = (value) => {
    this.setState({ showSchoolModal: value });
  };

  handleUpdateSchoolModal = (value) => {
    this.setState({ updateSchoolModal: value });
  };

  onCampaignAnalyticsPage = (value) => {
    if (value && value.id) {
      let { crrSchoolId } = this.state;
      this.props.history.push('/assessment/analytics/' + value.id + "/" + crrSchoolId);
    }
  }

  handleEditSchoolModal = (value) => {
    let data = {
      "id": value.id,
      "name": value.name,
      "email": value.email,
      "mobile": value.mobile
    }
    this.setState({ updateFormSchoolData: data, updateSchoolModal: value });
  };


  onCreateCampaign = (value) => {

    let data = {
      "id": this.state.crrSchoolId
    }
    this.setState({ openCampaignModel: data }, () => {
      let paginationData = {
        schoolId: data.id,
        keyWord: "",
        pageNo: 1,
        size: 10
      }
      this.props.dispatch(assessmentActions.getSchoolCampaignList(paginationData));
    });
  };


  closeCreateCampModal = () => {
    this.setState({ openCampaignModel: "" });
  };



  handleDeleteSchoolModal = (value) => {
    this.setState({ deleteSchoolModal: value });
  };

  gotoPage2 = () => {
    this.props.history.push('/assessment/student-school/');
  };


  handleSchoolInput = (event) => {
    let { formSchoolData } = this.state;
    formSchoolData[event.target.name] = event.target.value;
    this.setState({ formSchoolData });
  };

  saveNewSchool = () => {
    let { name, email, mobile } = this.state.formSchoolData;
    let data = {
      "name": name,
      "email": email,
      "mobile": mobile
    }

    let paginationData = {
      "keyWord": "",
      "pageNo": 1,
      "size": this.state.size
    }
    this.props.dispatch(assessmentActions.createSchool(data, paginationData));

    setTimeout(() => {
      this.setState({
        formSchoolData: {
          "name": "",
          "email": "",
          "mobile": ""
        },
        showSchoolModal: false
      })
    }, 500)
  }

  handleUpdateSchoolInput = (event) => {
    let { updateFormSchoolData } = this.state;
    updateFormSchoolData[event.target.name] = event.target.value;
    this.setState({ updateFormSchoolData });
  };

  saveUpdateSchool = () => {
    let { id, name, email, mobile } = this.state.updateFormSchoolData;
    let data = {
      "id": id,
      "name": name,
      "email": email,
      "mobile": mobile
    }

    let paginationData = {
      "keyWord": "",
      "pageNo": 1,
      "size": this.state.size
    }
    this.props.dispatch(assessmentActions.updateSchool(data, paginationData));

    setTimeout(() => {
      this.setState({
        updateFormSchoolData: {
          "id": "",
          "name": "",
          "email": "",
          "mobile": ""
        },
        updateSchoolModal: false
      })
    }, 500)
  }

  handleSearchSchool = (event, data) => {
    event.preventDefault();
    let { value } = event.target;
    let paginationData = {
      "keyWord": value,
      "pageNo": 1,
      "size": this.state.size,
      "schoolId": this.state.schoolId
    }
    this.props.dispatch(assessmentActions.getSchoolList(paginationData));
    // const { schoolId } = this.state;
    // if (!schoolId) {
    //   this.setState({
    //     error: 'Please select School first',
    //   });
    // } else {
    //   this.setState({
    //     searchEmployee: value, data, error: ''
    //   }, () => {
    //     let paginationData = {
    //       "keyWord": value,
    //       "pageNo": 1,
    //       "size": this.state.size,
    //       "schoolId": this.state.schoolId
    //     }
    //     this.props.dispatch(assessmentActions.getSchoolLis(paginationData));
    //   });
    // }
  }


  handleDownloadExcel() {
    const { getCoachCampaignListData } = this.props.assessment;

    // Prepare data for Excel
    const data = getCoachCampaignListData.map((school, index) => ({
      SNo: index + 1,
      SchoolName: school.name || "",
      Email: school.email || "",
      Mobile: school.mobile || "",
      Students: school.students || "",
      Status: school.status || "Not Assigned",
    }));

    // Create a worksheet from the data
    const ws = XLSX.utils.json_to_sheet(data);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "School");

    // Write the file
    const wbout = XLSX.write(wb, { bookType: "xlsx", type: "array" });
    saveAs(new Blob([wbout], { type: "application/octet-stream" }), "school.xlsx");
  }

  setCampaignFormData = (data) => {
    this.setState({ campaignFormData: data });
  }

  saveCampaign = () => {
    let { campaignFormData, openCampaignModel } = this.state;
    if (openCampaignModel && openCampaignModel.id) {
      let data = {
        ...campaignFormData,
        list: campaignFormData.list.map((ele) => ({ employeeId: ele.employeeId.toString(), studentId: ele.studentId.toString() })),
        schoolId: openCampaignModel.id
      }

      let tempData = {
        "keyWord": "",
        "pageNo": 1,
        "size": this.state.campsize,
        "schoolId": this.state.crrSchoolId
      }
      this.props.dispatch(assessmentActions.saveSchoolCampaign(data, tempData));
    }

    setTimeout(() => {
      this.setState({
        openCampaignModel: "",
        campaignFormData: {
          title: "",
          subject: "",
          emailName: "",
          message: "",
          teamname: "",
          list: []
        }
      });
    }, 500);

  }

  render() {

    let { assessment } = this.props;
    let { getCoachCampaignListData, getCoachCampaignListTotal, getSchoolCampaignListData, getSchoolCampaignListTotal } = assessment;
    let { campaignFormData, openCampaignModel, formSchoolData, updateFormSchoolData } = this.state;

    let { showSchoolModal, updateSchoolModal, deleteSchoolModal } = this.state;
    console.log('campaignFormData---->', campaignFormData)
    const checkFormat = (ele, field) => {
      return ele && ele[field] ? ele[field] : ""
    }

    const data = getCoachCampaignListData && getCoachCampaignListData.length > 0 ? getCoachCampaignListData.map((ele) => ({
      id: checkFormat(ele, "id"),
      title: checkFormat(ele, "title"),
      students: checkFormat(ele, "count"),
      date: checkFormat(ele, "createdAt")
        ? moment(checkFormat(ele, "createdAt"))
          .utcOffset("+05:30")
          .format("DD/MM/YYYY")
        : "",
      codes: ele && ele.employees && ele.employees.length > 0 ? ele.employees.length : 0
    })) : []

    return (
      <>
        <StudentHeader />

        {openCampaignModel ?
          <div className="flex items-start justify-center pb-10 bg-[#FAFAFA]">
            <section className="my-5 px-4 xl:w-11/12 mx-auto w-full xl:px-0">

              <div
                onClick={this.closeCreateCampModal}
                className="
                  flex items-center gap-2 my-2
                  cursor-pointer
                  group
                "
              >
                {/* Circular Icon */}
                <div
                  className="
                    w-7 h-7
                    flex items-center justify-center
                    rounded-full
                    bg-[#009EA7]
                    transition
                    group-hover:bg-[#007f86]
                  "
                >
                  <IoArrowBack className="w-5 h-5 text-white" />
                </div>

                {/* Optional Text */}
                <span className="text-lg font-semibold text-[#212121] group-hover:text-[#009EA7]">
                  Back
                </span>
              </div>



              <div className="bg-white border p-4">
                {/* Table design secction */}
                <div className="w-full flex-1 space-y-4">

                  <SendCampaign
                    getSchoolCampaignListData={getSchoolCampaignListData}
                    getSchoolCampaignListTotal={getSchoolCampaignListTotal}
                    campaignFormData={campaignFormData}
                    setCampaignFormData={this.setCampaignFormData}
                    saveCampaign={this.saveCampaign}
                  />
                </div>
              </div>
            </section>
          </div>
          :
          <div className="flex items-start justify-center pb-10 bg-[#FAFAFA]">
            <section className="my-5 px-4 xl:w-11/12 mx-auto w-full xl:px-0">
              <div className="flex space-x-4">
                <div
                  onClick={this.gotoPage2}
                  className="
                                          flex items-center gap-2 my-2
                                          cursor-pointer
                                          group
                                        "
                >
                  {/* Circular Icon */}
                  <div
                    className="
                                            w-7 h-7
                                            flex items-center justify-center
                                            rounded-full
                                            bg-[#009EA7]
                                            transition
                                            group-hover:bg-[#007f86]
                                          "
                  >
                    <IoArrowBack className="w-5 h-5 text-white" />
                  </div>
                </div>

                <h1 className="py-4 font-semibold text-2xl text-[#212121]">Campaign List</h1>
              </div>
              <div className="bg-white border p-4">
                {/* Table design secction */}
                <div className="w-full flex-1 space-y-4">
                  <div className="items-stretch justify-between space-y-4 lg:flex md:space-x-6 md:space-y-0">
                    <div className="flex space-x-3 items-center">
                      <div className="flex space-x-2 capitalize items-center text-sm text-[#212121]/70 font-medium">
                        <span>Show</span>
                        <form class="w-16">
                          <select id="entries" class="bg-white border border-gray-300 text-[#212121] text-sm rounded-md block w-full px-2 py-1.5 focus:outline-none">
                            <option value="10">10</option>
                            <option value="25">25</option>
                            <option value="50">50</option>
                            <option value="100">100</option>
                          </select>
                        </form>
                        <span>entries</span>
                      </div>
                    </div>

                    <div className="flex space-x-4">
                      <div className="w-full flex justify-between border px-4 text-[#212121]/70 bg-white rounded-md text-sm items-center  overflow-hidden">
                        <IoIosSearch className="w-5 h-5" />
                        <input type="search" name="search" onChange={() => { }} placeholder="Search by name" className="w-44 focus:outline-none px-2 py-2 text-[#212121]/70 placeholder-[#212121]/70 placeholder:font-normal font-medium " />
                      </div>

                      <button onClick={() => this.onCreateCampaign(true)} className="cursor-pointer bg-[#2196F3] text-white space-x-1 text-sm  border-[#2196F3] flex justify-between px-4 items-center py-2 rounded-md whitespace-nowrap">
                        <svg xmlns="http://www.w3.org/2000/svg" class="icon icon-tabler icon-tabler-circle-plus" width="24" height="24" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round" >
                          <path stroke="none" d="M0 0h24v24H0z" fill="none" /><circle cx="12" cy="12" r="9" />  <line x1="9" y1="12" x2="15" y2="12" />  <line x1="12" y1="9" x2="12" y2="15" /></svg><span> Create Campaign</span>
                      </button>
                    </div>
                  </div>

                  <div className="w-full mx-auto">
                    <div className="inline-block min-w-full">
                      <table className="min-w-full border">
                        <thead className="bg-gray-50">
                          <tr>
                            <th className="px-3 w-20 py-3 text-center border text-sm font-semibold text-gray-900">S.No.</th>
                            <th className="px-3 py-3 text-left border text-sm font-semibold text-gray-900">Campaign Name</th>
                            <th className="px-3 py-3 text-left border text-sm font-semibold text-gray-900">Date Created</th>
                            {/* <th className="px-3 py-3 text-left border text-sm font-semibold text-gray-900">No of Students</th> */}
                            {/* <th className="px-3 py-3 text-left border text-sm font-semibold text-gray-900">Role</th> */}
                            {/* <th className="px-3 py-3 text-left border text-sm font-semibold text-gray-900">Status</th> */}
                            <th className="px-3 py-3 text-center border text-sm font-semibold text-gray-900">Actions</th>
                          </tr>
                        </thead>
                        <tbody className="border divide-gray-200 bg-white">
                          {data && data.length > 0 ? (
                            data.map((item, index) => (
                              <tr key={index} className="hover:bg-gray-100">
                                <td className="whitespace-nowrap px-2 py-2 border text-sm text-center">{index + 1}</td>
                                <td className="whitespace-nowrap px-2 py-2 border text-sm">{item.title}</td>
                                <td className="whitespace-nowrap px-2 py-2 border text-sm">{item.date}</td>
                                {/* <td className="whitespace-nowrap px-2 py-2 border text-sm">
                                  <div className="flex items-center space-x-2 border p-1 w-32 justify-center cursor-pointer" onClick={() => this.gotoPage2("student-list/" + item.id.toString())}>
                                    <p className="border-b border-[#212121] text-[#212121] font-medium">{item && item.students > 0 ? item.students : 0} Student</p>
                                    <IoIosArrowForward className="w-5 h-5" />
                                  </div>
                                </td> */}

                                {/* <td className="whitespace-nowrap px-2 py-2 border text-sm w-44">
                                  <select
                                    id="entries"
                                    className={`bg-gray-50 border cursor-pointer border-gray-300 text-gray-900 text-sm rounded-md block w-full px-1 py-1.5 focus:outline-none ${item.status === 'Active' ? 'bg-green-500 text-white' : 'bg-white text-gray-900'}`}
                                  >
                                    <option className="option" value="Inactive" selected={item.status === 'Inactive'}>Inactive</option>
                                    <option className="option" value="Active" selected={item.status === 'Active'}>Active</option>
                                  </select>
                                </td> */}

                                <td className="whitespace-nowrap px-2 py-2 border text-sm">
                                  <div className="flex justify-center items-center space-x-2">
                                    <button onClick={() => this.onCampaignAnalyticsPage(item)} className="text-base border rounded-md p-1 cursor-pointer text-[#212121]/70 hover:bg-[#2196F3] hover:text-white">
                                      <MdOutlineAnalytics size={18} />
                                    </button>
                                    <button onClick={() => this.handleEditSchoolModal(item)} className="text-base border rounded-md p-1 cursor-pointer text-[#212121]/70 hover:bg-[#2196F3] hover:text-white">
                                      <MdOutlineEdit size={18} />
                                    </button>
                                  </div>
                                </td>

                              </tr>
                            ))
                          ) : (
                            <tr>
                              <td colSpan="9" className="px-4 py-8 text-center">
                                <div className="flex flex-col items-center space-y-4 justify-center md:py-8 py-6">
                                  <img src="/assessment_images/no-users.svg" alt="no-users" className="w-36 2xl:w-40" />
                                  <h2 className="capitalize md:text-3xl text-2xl font-semibold text-[#3D405B] pt-4">Campaign not found!</h2>
                                  <p className="text-gray-500 text-lg">Looks like you haven't created any campaign yet.</p>
                                </div>
                              </td>
                            </tr>
                          )}
                        </tbody>
                      </table>
                    </div>
                  </div>

                </div>





                {/* Data not Found section */}
                {/* <section className="flex items-center justify-center w-full col-span-2 gap-10 px-4 mx-auto overflow-hidden">
                <div className="flex flex-col items-center space-y-4 justify-center md:py-10 py-8 text-center">
                  <img src="/assessment_images/no-users.svg" alt="no-users.svg" className="w-3/6 2xl:w-2/4" />
                  <h2 className="capitalize md:text-3xl text-2xl font-semibold text-[#3D405B] pt-4">Data not found!</h2>
                  <p className="text-gray-500 text-lg">Looks like you haven’t added any user yet.</p>
                  <div className="mt-0 md:mt-4 bg-[#2196F3] border border-[#2196F3] text-white py-2 px-5 rounded uppercase flex items-center justify-center space-x-3">
                    <span><svg width="30" height="30" viewBox="0 0 81 80" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M30.3281 40H50.3281M40.3281 30V50M10.3281 40C10.3281 43.9397 11.1041 47.8407 12.6117 51.4805C14.1194 55.1203 16.3292 58.4274 19.1149 61.2132C21.9007 63.999 25.2079 66.2087 28.8476 67.7164C32.4874 69.224 36.3885 70 40.3281 70C44.2678 70 48.1689 69.224 51.8086 67.7164C55.4484 66.2087 58.7556 63.999 61.5413 61.2132C64.3271 58.4274 66.5369 55.1203 68.0445 51.4805C69.5522 47.8407 70.3281 43.9397 70.3281 40C70.3281 36.0603 69.5522 32.1593 68.0445 28.5195C66.5369 24.8797 64.3271 21.5726 61.5413 18.7868C58.7556 16.001 55.4484 13.7913 51.8086 12.2836C48.1689 10.776 44.2678 10 40.3281 10C36.3885 10 32.4874 10.776 28.8476 12.2836C25.2079 13.7913 21.9007 16.001 19.1149 18.7868C16.3292 21.5726 14.1194 24.8797 12.6117 28.5195C11.1041 32.1593 10.3281 36.0603 10.3281 40Z" stroke="white" stroke-width="3" stroke-linecap="round" stroke-linejoin="round" />
                    </svg></span>
                    <button className="">Add New School</button>
                  </div>
                </div>
              </section> */}



              </div>

            </section>
          </div>}

        {showSchoolModal ? (
          <>
            <NewSchoolModal
              handleNewSchoolModal={this.handleNewSchoolModal}
              handleSchoolInput={this.handleSchoolInput}
              formSchoolData={formSchoolData}
              saveNewSchool={this.saveNewSchool}
            />
          </>
        ) : null}

        {updateSchoolModal ? (
          <>
            <SchoolEditModal
              handleUpdateSchoolModal={this.handleUpdateSchoolModal}
              handleUpdateSchoolInput={this.handleUpdateSchoolInput}
              updateFormSchoolData={updateFormSchoolData}
              saveUpdateSchool={this.saveUpdateSchool}
            />
          </>
        ) : null}

        {deleteSchoolModal ? (
          <>
            <DeleteSchoolModal
              handleDeleteSchoolModal={this.handleDeleteSchoolModal}
            />
          </>
        ) : null}
      </>
    );
  }
}

function mapStateToProps(state) {
  //console.log("state  ", state);
  const { loggingIn } = state.authentication;
  const { questions, user, assessment } = state;
  return {
    loggingIn,
    questions,
    user,
    assessment,
  };
}

export default connect(mapStateToProps)(CampaignList);
